// Hand-maintained — override generation
// F-6: Exposes the admin audit surface for ownership transfers.
// This SDK is NOT available on the client package by design — ownership
// audit logs are tenant-scope administration, not end-user data.
import { RequestBuilder } from "../request-builder";

export interface OwnershipTransfer {
  id: string;
  type: "ownership-transfer";
  attributes: {
    resource_type: string;
    resource_id: string;
    from_user_id: string | null;
    to_user_id: string | null;
    transferred_by_type: "user" | "application";
    transferred_by_id: string;
    workspace_id: string;
    reason: string | null;
    inserted_at: string;
  };
}

export interface OwnershipTransferListResult {
  data: OwnershipTransfer[];
  meta?: { total?: number };
}

export interface OwnershipTransferListParams {
  workspace_id: string;
  resource_type?: string;
  from_user_id?: string;
  to_user_id?: string;
}

export function createOwnershipTransfersNamespace(rb: RequestBuilder) {
  return {
    /**
     * List ownership transfer audit records scoped to a workspace.
     *
     * Requires `authorization:read` scope on the API key, or a session user
     * with workspace access. Cross-tenant workspace_id values are rejected
     * (returns Forbidden).
     *
     * @param params - Filter parameters. `workspace_id` is required.
     * @returns Paginated list of ownership transfer records, newest first
     * @example
     * const transfers = await admin.ownershipTransfers.list({
     *   workspace_id: "workspace-uuid",
     *   resource_type: "agent",
     * });
     */
    async list(
      params: OwnershipTransferListParams,
    ): Promise<OwnershipTransferListResult> {
      const query = `?${new URLSearchParams(
        params as unknown as Record<string, string>,
      ).toString()}`;
      return rb.rawGet<OwnershipTransferListResult>(
        `/admin/ownership-transfers${query}`,
      );
    },
  };
}
